<template>
  <div class="mt-2" v-if="project && contacts && user">
    <v-toolbar flat class="menuButtons hidden-sm-and-down" height="60px">
      <v-btn @click="activateProjectTasks" :color="projectTasks ? 'primary darken-3' : 'primary darken-1'" dark><v-icon medium left>assignment_turned_in</v-icon><span class="title">Tasks and Notes</span></v-btn>
      <v-btn @click="activateProjectPlans" :color="projectPlans ? 'primary darken-3' : 'primary darken-1'" dark><v-icon medium left>border_outer</v-icon><span class="title">Pool Plans</span></v-btn>
      <v-btn @click="activateProjectFiles" :color="projectFiles ? 'primary darken-3' : 'primary darken-1'" dark><v-icon medium left>perm_media</v-icon><span class="title">Files</span></v-btn>
      <v-btn @click="activateProjectPhotos" :color="projectPhotos ? 'primary darken-3' : 'primary darken-1'" dark><v-icon medium left>photo_camera</v-icon><span class="title">Jobsite Photos</span></v-btn>
    </v-toolbar>
      <v-layout class="projectInfo" row wrap>
        <!-- Left Project Info Section -->
        <v-flex xs12 md5 lg4 pl-2 mt-2 v-if="!projectButtonSelection || (projectButtonSelection && projectButtonSelection === 'DETAILS')">
          <v-card>
            <v-toolbar dark color="secondary" flat height="64px">
              <v-toolbar-items><v-icon medium left>ballot</v-icon><span class="mt-4 ml-2 title font-weight-bold">{{ project.name }} {{ project.job_number ? '#' + project.job_number : '' }}</span></v-toolbar-items>
              <v-spacer></v-spacer>
              <v-btn v-if="canEdit" @click="editProjectDialog = true" flat icon><v-icon>edit</v-icon></v-btn>
            </v-toolbar>
            <div class="mapouter">
              <div class="gmap_canvas"><iframe height="200" width="100%" id="gmap_canvas" :src="'https://maps.google.com/maps?q=' + project.address + '%20' + project.city + '%20' + project.state + '%20' + project.zip + '&t=&z=13&ie=UTF8&iwloc=&output=embed'" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
              </div>
            </div>
            <v-toolbar @click="activateContactDialog(index)" dark color="secondary" flat height="64px" style="cursor: pointer" v-for="(contact, index) in contacts" :key="index">
              <v-btn round icon class="primary"><v-icon>phone</v-icon></v-btn>
              <span class="ml-2" style="font-size:18px">{{contact.company_name ? contact.company_name : contact.secondaryContact_first_name ? contact.first_name + ' ' + contact.last_name + ' and ' + contact.secondaryContact_first_name + ' ' + contact.secondaryContact_last_name : contact.first_name + ' ' + contact.last_name }}</span>
              <v-spacer></v-spacer>
              <v-btn flat icon><v-icon>edit</v-icon></v-btn>
            </v-toolbar>
            <div class="secondary pt-2 pb-2 pl-2 mt-1" style="cursor:pointer" @click="mapLink">
              <v-icon dark class="mr-2">location_on</v-icon><span class="subheading white--text">{{ project.address }}, {{ project.city }}, {{ project.state }} {{ project.zip }}</span>
            </div>
            <v-layout row mt-4 ml-2 indigo--text font-weight-bold>
              <v-flex xs1>
                <v-icon large color="indigo">today</v-icon>
              </v-flex>
              <v-flex xs3 ml-2>
                <div>Start Date:</div>
                <div>{{ project.start_date.seconds | moment("MMMM Do YYYY") }}</div>
              </v-flex>
              <v-flex xs1>
                <v-icon large color="indigo">check_box</v-icon>
              </v-flex>
              <v-flex xs4 ml-2>
                <div>Status:</div>
                <div>{{ project.status }}</div>
              </v-flex>
              <v-spacer></v-spacer>
              <v-layout>
              <v-flex @click="activateContactDialog(0)" xs1 style="cursor:pointer">
                <v-icon large color="indigo">contact_phone</v-icon>
              </v-flex>
              <v-flex @click="activateContactDialog(0)" xs4 style="margin-left:35px; cursor:pointer">
                <div>Customer</div>
                <div>Contact</div>
              </v-flex>
              </v-layout>
            </v-layout>
            <!-- Assigned Users -->
            <v-toolbar height="30px" class="secondary pt-2 pb-2 mt-3">
              <v-icon style="margin-left: -10px" dark class="mr-3">group</v-icon><span class="subheading white--text">Assigned Users</span>
              <v-spacer></v-spacer>
              <v-menu transition="slide-x-transition" bottom right>
              <v-btn v-if="canEdit" dark flat icon slot="activator"><v-icon>person_add</v-icon></v-btn>
                <v-list>
                  <v-list-tile v-for="(user, i) in userList" :key="i" @click="assignUser(user)">
                    <v-avatar class="mr-3">
                      <avatar :size="36" :username="user.first_name + ' ' + user.last_name" :src="user.avatar ? user.avatar : undefined"></avatar>
                    </v-avatar>
                    <v-list-tile-title class="font-weight-strong">{{ user.first_name + ' ' + user.last_name }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
            <v-layout row wrap mt-3 ml-2>
              <div v-if="assignedUsers.length > 0" v-for="(user, i) in assignedUsers" :key="i">
              <v-badge overlap color="grey" class="ml-2">
              <span v-if="canEdit" @click="removeAssignedUser(user)" style="cursor:pointer" slot="badge">X</span>
              <v-avatar>
                <v-tooltip top>
                  <avatar slot="activator" :username="user.first_name + ' ' + user.last_name" :src="user.avatar ? user.avatar : undefined"></avatar>{{ user.first_name + ' ' + user.last_name }}
                </v-tooltip>
              </v-avatar>
              </v-badge>
              </div>
              <span class="ml-2" v-if="assignedUsers.length < 1">No Assigned Users</span>
            </v-layout>
            <!-- End: Assigned Users -->
            <!-- Additional Contact -->
            <v-toolbar height="30px" class="secondary pt-2 pb-2 mt-3">
              <v-icon style="margin-left: -10px" dark class="mr-3">people_outline</v-icon><span class="subheading white--text">Additional Contacts</span>
              <v-spacer></v-spacer>
              <v-btn v-if="canEdit" @click="additionalContactDialog = true" dark flat icon><v-icon>person_add</v-icon></v-btn>
            </v-toolbar>
            <v-list two-line>
              <v-list-tile v-if="additionalContacts && additionalContacts.length > 0" v-for="(contact, index) in additionalContacts" :key="index">
                <v-list-tile-content>
                  <v-list-tile-title>Name: {{ contact.name }}</v-list-tile-title>
                  <v-list-tile-sub-title style="cursor:pointer" @click="contactLinks('email', contact.email)" v-if="contact.email">Email: {{ contact.email }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title style="cursor:pointer" @click="contactLinks('phone', contact.phone)" v-if="contact.phone">Phone: {{ formatPhoneNumber(contact.phone) }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn v-if="canEdit" @click="editAdditionalContact = {contact: contact, index: index}; additionalContactDialog = true" icon ripple>
                    <v-icon color="grey lighten-1">edit</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-action>
                  <v-btn v-if="canEdit" @click="deleteAdditionalContact({contact: contact, index: index})" icon ripple>
                    <v-icon color="grey lighten-1">cancel</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider v-if="additionalContacts && additionalContacts.length > 0" class="mt-3"></v-divider>
            </v-list>
            <span class="ml-3" v-if="!additionalContacts || additionalContacts.length < 1">No Additional Contacts</span>
            <!-- End: Additional Contacts -->
            <v-layout mt-2 row wrap v-if="project.building_dept">
              <v-flex>
                <div class="subheading pt-2 pb-2 pl-2">
                  <h3>Building Department</h3>
                  <p>{{ project.building_dept }}</p>
                </div>
              </v-flex>
            </v-layout>
            <v-layout mt-2 row wrap v-if="builderInfo">
              <v-flex>
                <div class="subheading pt-2 pb-2 pl-2">
                  <h3>Builder Information</h3>
                  <p v-if="project.builder">Builder: {{ project.builder }}</p>
                  <p v-if="project.builder_contact">Builder Contact: {{ project.builder_contact }}{{ builderContact && builderContact.title ? ', ' + builderContact.title : '' }}</p>
                  <div style="cursor:pointer" v-if="builderContact">
                    <p v-if="builderContact.phone" @click="contactLinks('phone', builderContact.phone)">Contact Phone: {{ formatPhoneNumber(builderContact.phone) }}</p>
                    <p v-if="builderContact.email" @click="contactLinks('email', builderContact.email)">Contact Email: {{ builderContact.email }}</p>
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <v-divider v-if="builderInfo"></v-divider>
            <v-layout mt-2 row wrap v-if="neighborhoodInfo">
              <v-flex>
                <div class="subheading pt-2 pb-2 pl-2">
                  <h3>Neighborhood Information</h3>
                  <p v-if="project.hoa">HOA: {{ project.hoa }}</p>
                  <p v-if="project.gate_code">Gate Code: {{ project.gate_code }}</p>
                </div>
              </v-flex>
            </v-layout>
            <v-divider v-if="neighborhoodInfo"></v-divider>
            <v-layout v-if="salesInfo">
              <div class="subheading pt-2 pb-2 pl-2">
                <h3>Sales Information</h3>
                <p class="subheading" v-if="project.budget_min > 0 || project.budget_max > 0">Budget: {{ formatCurrency(project.budget_min) }} - {{ formatCurrency(project.budget_max) }}</p>
                <p class="subheading" v-if="project.property_survey">Property Survey: {{ project.property_survey }}</p>
                <p class="subheading" v-if="project.other_designs">Other Designs: {{ project.other_designs }}</p>
                <p class="subheading" v-if="project.financing">Financing: {{ project.financing }}</p>
              </div>
            </v-layout>
            <v-divider v-if="salesInfo"></v-divider>
            <v-layout mt-2 v-if="project.description">
              <div class="subheading pt-2 pb-2 pl-2">
                <h3>Project Description</h3>
                <span class="subheading" v-if="project.description">{{ project.description }}</span>
              </div>
            </v-layout>
            <v-layout>
              <v-flex>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <!-- End: Left Project Info Section -->
        <!-- Right Dynamic Content -->
        <v-flex xs12 md7 lg8 pl-2 pt-2 v-if="(!projectButtonSelection && projectTasks) || (projectButtonSelection && projectButtonSelection === 'TASKS' || projectButtonSelection === 'NOTES')"> 
          <project-tasks :project="project" :projectButtonSelection="projectButtonSelection" />
        </v-flex>
        <v-flex xs12 md7 lg8 pl-2 pt-2 v-if="(!projectButtonSelection && projectFiles) || (projectButtonSelection && projectButtonSelection === 'FILES')"> 
          <project-files :project="project" />
        </v-flex>
        <v-flex xs12 md7 lg8 pl-2 pt-2 v-if="(!projectButtonSelection && projectPlans) || (projectButtonSelection && projectButtonSelection === 'PLANS')"> 
          <project-plans @reloadPlans="reloadPlans" :project="project" />
        </v-flex>
        <v-flex xs12 md7 lg8 pl-2 pt-2 v-if="(!projectButtonSelection && projectPhotos) || (projectButtonSelection && projectButtonSelection === 'PHOTOS')"> 
          <project-photos :project="project" />
        </v-flex>
        <!-- End: Right Dynamic Content -->
      </v-layout>
    <!-- Edit Project Dialog -->
    <v-dialog max-width="800px" persistent v-model="editProjectDialog">
      <edit-project :editContact="contacts[0]" :editProject="project" v-if="editProjectDialog" @closeDialog="editProjectDialog = false"/>
    </v-dialog>
    <!-- Edit Project Dialog -->
    <!-- Contact Information -->
    <v-dialog max-width="600px" v-model="contactDialog">
      <contact-dialog v-if="contactDialog" @contactProjectChange="contactProjectChange" :projectContact="contactProp" :project="project" :changeContact="true" @builderToCustomerChange="builderToCustomerChange" @closeDialog="contactDialog = false" @changeContactDialog="contactDialog = false; changeContactDialog = true"/>
    </v-dialog>
    <!-- End: Contact Information -->
    <!-- Change Contact Information -->
    <v-dialog v-model="changeContactDialog" persistent max-width="500">
      <v-card>
        <v-toolbar dark color="secondary" flat height="64px">
          <v-toolbar-items><span class="mt-4 ml-2 title font-weight-bold">Change project customer?</span></v-toolbar-items>
        </v-toolbar>
        <v-card-text>You are choosing to assign this project to a different customer. Please select the desired customer from the list.</v-card-text>
          <!-- Existing Customer / Builder Selection -->
          <v-layout>
            <v-toolbar dark color="primary">
              <v-autocomplete autofocus :items="contactList" v-model="customerSelect" cache-items
                class="mx-3" flat hide-no-data hide-details label='Search Customers' solo-inverted>
              </v-autocomplete>
            </v-toolbar>
          </v-layout>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="changeCustomer">Change Customer</v-btn>
          <v-btn color="secondary" text @click="changeContactDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End: Change Contact Information -->
    <!-- Additional Contacts -->
    <v-dialog max-width="600px" v-model="additionalContactDialog">
      <additional-contact v-if="additionalContactDialog" :project="project" :editAdditionalContact="editAdditionalContact" @closeDialog="additionalContactDialog = false; editAdditionalContact = null"/>
    </v-dialog>
    <!-- End: Additional Contacts -->
  </div>
</template>

<script>
import Avatar from 'vue-avatar'
import EditProject from './CreateProject'
import ProjectTasks from './ProjectTasks'
import ProjectPlans from './ProjectPlans'
import ProjectChangeOrders from './ProjectChangeOrders'
import ProjectFiles from './ProjectFiles'
import ProjectPhotos from './ProjectPhotos'
import ContactDialog from '../contacts/ContactDialog'
import AdditionalContact from './AdditionalContact'
import { db } from '../../firebaseInit'
import _ from 'lodash'

export default {
  props: ['id', 'projectButtonSelection'],
  data () {
    return {
      editAdditionalContact: null,
      additionalContactDialog: false,
      projectTasks: true,
      projectPlans: false,
      projectPhotos: false,
      projectChangeOrders: false,
      projectFiles: false,
      contacts: null,
      contactProp: null,
      editProjectDialog: false,
      contactDialog: false,
      changeContactDialog: false,
      customerSelect: null
    }
  },
  watch: {
    project () {
      if (this.project) {
        this.getTasks()
        this.getContacts()
      }
    }
  },
  destroyed () {
    this.$store.dispatch('destroyProject')
    this.$store.dispatch('destroyProjectTasks')
  },
  mounted () {
    this.$store.dispatch('getProject', this.id)
    this.$store.dispatch('getProjectNotes', this.id)
    this.$store.dispatch('getFileList', this.id)
  },
  computed: {
    contactList () {
      let concatResults = [...this.$store.getters.builderList.map(a => a.company_name), ...this.$store.getters.getContactSearchList.map(a => a.name)]
      concatResults = concatResults.filter(f => !!f)
      return concatResults
    },
    canEdit () {
      return this.permissions.edit.all || (this.permissions.edit.assigned && this.project.assigned)
    },
    permissions () {
      return this.$store.getters.user.permissions.projects
    },
    additionalContacts () {
      if (this.project.additional_contacts) {
        return this.project.additional_contacts.filter(f => f.deleted === false)
      }
    },
    assignedUsers () {
      let assigned = []
      this.project.assigned_to.forEach(user => {
        assigned.push(this.$store.getters.userList.concat(this.$store.getters.inactiveUsers).filter(f => f.id === user)[0])
      })
      return assigned
    },
    userList () {
      return _.orderBy(this.$store.getters.userList, 'first_name')
    },
    userFullName (firstName, lastName) {
      return firstName + ' ' + lastName
    },
    builderContact () {
      const builderContacts = this.$store.getters.builderList
      if (builderContacts) {
        const builder = builderContacts.filter(filter => filter.company_name === this.project.builder)
        if (builder && builder.length > 0) {
          const contacts = builder[0].builder_contacts
          const index = contacts.findIndex(i => i.first_name + ' ' + i.last_name === this.project.builder_contact)
          return contacts[index]
        }
      }
    },
    project () {
      const getProject = this.$store.getters.getProject
      return getProject
    },
    builderInfo () {
      if (this.project.builder || this.project.builder_contact || this.project.builder_contact_phone || this.project.builder_contact_email) {
        return true
      }
    },
    neighborhoodInfo () {
      if (this.project.hoa || this.project.gate_code) {
        return true
      }
    },
    user () {
      return this.$store.getters.user
    },
    salesInfo () {
      if (this.project.budget || this.project.property_survey || this.project.other_designs || this.project.financing) {
        return true
      }
    }
  },
  methods: {
    builderToCustomerChange (newContact) {
      this.contacts = [newContact]
    },
    changeCustomer () {
      if (!this.customerSelect) {
        alert('You must select a new customer!')
      } else {
        const allContacts = [...this.$store.getters.getContactSearchList, ...this.$store.getters.builderList]
        let toContact = null
        allContacts.forEach(contact => {
          if (contact.company_name && contact.company_name === this.customerSelect) {
            toContact = contact
            return
          }
          if (contact.name && contact.name === this.customerSelect) {
            toContact = contact
          }
        })
        const payload = {project: this.project, fromContact: this.contacts[0], toContact: toContact}
        this.$store.dispatch('changeProjectCustomer', payload)
        this.changeContactDialog = false
        db.collection('contacts').doc(payload.toContact.id).get().then(contact => {
          this.contacts = [contact.data()]
        })
      }
      this.customerSelect = null
    },
    contactProjectChange (value) {
      this.contacts[0] = {...this.contacts[0], ...value}
      this.contactProp = {...this.contactProp, ...value}
    },
    deleteAdditionalContact (payload) {
      if (confirm('Are you sure you want to delete the Additional Contact: ' + payload.contact.name + '?')) {
        this.project.additional_contacts[payload.index].deleted = true
        this.$store.dispatch('additionalContact', { project: this.project, type: 'delete', contactName: payload.contact.name })
      }
    },
    reloadPlans () {
      this.projectPlans = false
      setTimeout(this.PoolPrintActive, 500)
    },
    PoolPrintActive () {
      this.projectPlans = true
    },
    removeAssignedUser (user) {
      if (confirm('Are you sure you want to remove the assigned user: ' + user.first_name + ' ' + user.last_name + '?')) {
        const index = this.project.assigned_to.findIndex(i => i === user.id)
        this.project.assigned_to.splice(index, 1)
        this.$store.dispatch('removeAssignedUser', { project: this.project, user: user })
      }
    },
    assignUser (user) {
      this.project.assigned_to.push(user.id)
      this.$store.dispatch('assignUser', { project: this.project, user: user })
    },
    mapLink () {
      window.open('https://www.google.com/maps?q=' + this.project.address + '%20' + this.project.city + '%20' + this.project.state + '%20' + this.project.zip)
    },
    activateProjectFiles () {
      this.projectTasks = false
      this.projectPlans = false
      this.projectFiles = true
      this.projectPhotos = false
    },
    activateProjectPlans () {
      this.projectTasks = false
      this.projectPlans = true
      this.projectFiles = false
      this.projectPhotos = false
    },
    activateProjectTasks () {
      this.projectTasks = true
      this.projectPlans = false
      this.projectFiles = false
      this.projectPhotos = false
    },
    activateProjectPhotos () {
      this.projectTasks = false
      this.projectPlans = false
      this.projectFiles = false
      this.projectPhotos = true
    },
    contactLinks (type, value) {
      // window.open('mailto: ' + value)
      if (type === 'email') {
        location.href = 'mailto: ' + value
      }
      if (type === 'phone') {
        location.href = 'tel:' + value
      }
      if (type === 'address') {
        window.open('https://www.google.com/maps?q=' + value)
      }
    },
    formatPhoneNumber (value) {
      let s2 = ('' + value).replace(/\D/g, '')
      let m = s2.match(/^(\d{3})(\d{3})(\d{4})$/)
      return (!m) ? null : '(' + m[1] + ')' + ' ' + m[2] + '-' + m[3]
    },
    activateContactDialog (index) {
      this.contactDialog = true
      this.contactProp = this.contacts[index]
    },
    getContacts () {
      let contactArray = []
      // Get Active Contacts Only
      let obj = this.project.contacts
      Object.keys(obj).forEach(key => {
        if (!obj[key]) delete obj[key]
      })
      // Turn Object Into Array
      let contactIds = Object.keys(obj)
      // Get Projects
      contactIds.forEach(i => {
        db.collection('contacts').doc(i).get().then(doc => {
          let contactData = doc.data()
          contactData = {...contactData, id: doc.id}
          contactArray.push(contactData)
        })
      })
      this.contacts = contactArray
    },
    getTasks () {
      if (this.project.tasks) {
        let array = Object.keys(this.project.tasks).map(key => { return [key] })
        this.$store.dispatch('getProjectTasks', array)
      } else {
        console.log('There are no tasks for this project.')
      }
    },
    formatCurrency (value) {
      return '$' + (parseInt(value)).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    }
  },
  components: {
    Avatar,
    EditProject,
    ProjectTasks,
    ProjectPlans,
    ProjectChangeOrders,
    ProjectFiles,
    ProjectPhotos,
    AdditionalContact,
    ContactDialog
  }
}
</script>

<style scoped>
.menuButtons .v-btn {
  border-radius: 10px;
  height: 55px;
}
.projectInfo p {
  margin-top: 10px;
  line-height: 10px;
  display: block;
}
</style>




// WEBPACK FOOTER //
// src/components/projects/Project.vue